import { Alert, AlertIcon, Box, Flex, Spinner } from '@chakra-ui/react'
import React from 'react'

import { useTranslation } from 'react-i18next'
import ProductList from './ProductList'

interface ProductDetailsProps {
  debouncedSearch: string
  products: any
  hasNextPage: boolean
  isFetchingNextPage: boolean
  loadMore: () => void
  status: string
}

const ProductDetails: React.FC<ProductDetailsProps> = ({ ...props }) => {
  const { t } = useTranslation()
  return (
    <Box flex={1} minHeight={'1000px'}>
      {props.status === 'loading' && (
        <Flex justify='center' align='center' my={5}>
          <Spinner />
        </Flex>
      )}

      {props.status === 'error' && (
        <Alert status='error' borderRadius={4} my={5}>
          <AlertIcon />
          {t('products.errorLoadingProducts')}
        </Alert>
      )}

      {props.status === 'success' && (
        <ProductList
          products={props.products}
          loadMore={props.loadMore}
          hasNextPage={props.hasNextPage}
          isFetchingNextPage={props.isFetchingNextPage}
        />
      )}
    </Box>
  )
}

export default ProductDetails
